import { useState } from 'react'
import { useAdminRoles } from '../../../features/admin/use-admin-roles'
import { useAdminUsers, useAssignUserRole } from '../../../features/admin/use-admin-users'
import { AdminPage, adminError, Meta, rowCls } from './admin-bits'
import { Empty, Inline, inputCls, td, th } from './controls'
import { mono, Panel } from './ui'

export function SignalAdminUsers() {
  const users = useAdminUsers()
  const roles = useAdminRoles()
  const assign = useAssignUserRole()
  const [target, setTarget] = useState<string | null>(null)
  const list = users.data ?? []
  const roleOpts = roles.data ?? []
  return (
    <AdminPage
      page="users"
      title="Users"
      meta={<Meta>{list.length} members</Meta>}
      loading={users.isLoading}
      error={!!users.error}
    >
      {assign.error ? <Inline tone="bad">{adminError(assign.error)}</Inline> : null}
      <Panel title="Members">
        {list.length === 0 ? (
          <Empty>No users in this organization.</Empty>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr>
                  <th className={th}>Name</th>
                  <th className={th}>Email</th>
                  <th className={th}>Role</th>
                </tr>
              </thead>
              <tbody>
                {list.map((u) => (
                  <tr key={u.id} className={rowCls}>
                    <td className={`${td} font-medium`}>{u.name}</td>
                    <td className={`${td} text-[var(--color-muted)]`} style={mono}>
                      {u.email}
                    </td>
                    <td className={`${td} w-56 py-0`}>
                      <select
                        aria-label={`Role for ${u.name}`}
                        className={inputCls}
                        value={u.role}
                        disabled={assign.isPending && target === u.id}
                        onChange={(e) => {
                          setTarget(u.id)
                          assign.mutate({ userId: u.id, role: e.target.value })
                        }}
                      >
                        {roleOpts.some((r) => r.id === u.role) ? null : <option value={u.role}>{u.role}</option>}
                        {roleOpts.map((r) => (
                          <option key={r.id} value={r.id}>
                            {r.name}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </AdminPage>
  )
}
